import './Tabs.scss';
import Component from './Tabs';
export default Component;
